import request from '@/utils/request'

/** 年假发放规则（当前租户；未配置时返回系统默认） */
export const annualDayRuleApi = () => {
  return request({
    url: 'AnnualLeave/annualDayRule',
    method: 'post',
    data: {}
  })
}

/** 保存年假发放规则（全量替换当前租户配置） */
export const annualDayRuleSaveApi = (data) => {
  return request({
    url: 'AnnualLeave/adminSaveAnnualDayRule',
    method: 'post',
    data
  })
}
